import React from "react";
import { usePageTitle } from "../hooks/usePageTitle";
import Groups from "../components/BulkEmail/Groups";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const GroupsPage: React.FC = () => {
  usePageTitle("Groups Management");

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-4 mb-4">
            <Link
              to="/bulk-email"
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
              <span className="text-sm font-medium">Back to Bulk Email</span>
            </Link>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">
                Groups Management
              </h1>
              <p className="mt-2 text-gray-600">
                Create and manage recipient groups for targeted email campaigns
              </p>
            </div>
          </div>
        </div>

        {/* Groups Component */}
        <Groups />
      </div>
    </div>
  );
};

export default GroupsPage;
